import { PersonRequest } from "@plinknz/tah-website-elements";

import { equalish } from "../boolean-functions";
import { stringifyAddressFinder } from "../address";
import { getPhone, PhoneType } from "../phone";
import type { SVGLine } from "./svg";
import { AddressMeta } from "../../components/form/address-finder-input";

interface GetPersonalChangesProps {
  member: PersonRequest;
  phone: string;
  email: string;
  addressfinder: AddressMeta;
}
export function getPersonalChanges({
  member,
  phone,
  email,
  addressfinder,
}: GetPersonalChangesProps) {
  const personalChanges: SVGLine[] = [{ heading: "Contact Changes" }];
  const existingCell = getPhone({ phone: member.phone, type: PhoneType.Cell })
    ?.value;
  const existingPhone = getPhone({ phone: member.phone, type: PhoneType.Home })
    ?.value;

  if (!equalish(phone, existingCell) && !equalish(phone, existingPhone)) {
    personalChanges.push({ label: "Phone", text: phone });
  }

  if (!equalish(email, member.email[0]?.value)) {
    personalChanges.push({ label: "Email", text: email });
  }

  if (addressfinder) {
    const existing = member.address[0];

    if (
      (!existing && addressfinder.address_line_1) ||
      !equalish(existing.line1, addressfinder.address_line_1) ||
      !equalish(existing.line2, addressfinder.address_line_2) ||
      !equalish(existing.city, addressfinder.city) ||
      !equalish(existing.postcode, addressfinder.postcode)
    ) {
      const newAddress = stringifyAddressFinder(addressfinder);
      personalChanges.push({
        label: "Address",
        text: newAddress,
      });
    }
  }

  if (personalChanges.length === 1) {
    return [];
  }

  return personalChanges;
}
